import { useMemo, useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router";
import { useSubscriptionsReport } from "../../hooks/useReportDashboard";
import { useAccountSubscriptions } from "../../hooks/useSubscribtionDashboard";
import { DEFAULT_SEARCH_BY } from "../../sections/subscriptionDashboard/users/usersScreen.constants";
import { buildTrialRow } from "../../sections/subscriptionDashboard/trials/trialsScreen.constants";
import {
  TrialsHeader,
  TrialsSummaryCards,
  TrialsUsersTable,
} from "../../sections/subscriptionDashboard/trials/TrialsScreenSections";
import { mapSubscriptionSummaryToKpis } from "../../utils/subscriptionSummary";

export default function TrialsScreen() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const trimmedQuery = searchQuery.trim();
  const offset = page * limit;

  const queryParams = useMemo(
    () => ({
      limit,
      offset,
      ...(trimmedQuery
        ? {
            searchBy: DEFAULT_SEARCH_BY,
            keyword: trimmedQuery,
          }
        : {}),
    }),
    [limit, offset, trimmedQuery],
  );

  const {
    data: usersData,
    isLoading: usersLoading,
    isError: usersError,
    error: usersErrorObj,
    refetch: usersRefetch,
  } = useAccountSubscriptions(queryParams);

  const {
    data: subscriptionReportsData,
    isLoading: summaryLoading,
    isError: summaryError,
    error: summaryErrorObj,
    refetch: summaryRefetch,
  } = useSubscriptionsReport();

  const users = useMemo(() => usersData?.data?.data ?? [], [usersData]);
  const trialRows = useMemo(() => users.map(buildTrialRow), [users]);
  const totalCount =
    usersData?.data?.meta?.total ?? usersData?.data?.meta?.totalCount ?? 0;

  const subscriptionSummaryCards = useMemo(
    () =>
      mapSubscriptionSummaryToKpis(
        subscriptionReportsData?.data?.subscriptionSummary,
      ),
    [subscriptionReportsData],
  );

  const handleViewUser = (accountId) => {
    if (!accountId) return;
    navigate(`/subscritionDashboard/users/${accountId}`);
  };

  return (
    <Box>
      <TrialsHeader />

      <TrialsSummaryCards
        loading={summaryLoading}
        isError={summaryError}
        error={summaryErrorObj}
        onRetry={() => summaryRefetch()}
        summaryCards={subscriptionSummaryCards}
      />

      <TrialsUsersTable
        searchQuery={searchQuery}
        onSearchChange={(value) => {
          setSearchQuery(value);
          setPage(0);
        }}
        usersLoading={usersLoading}
        usersError={usersError}
        usersErrorObj={usersErrorObj}
        onRetryUsers={() => usersRefetch()}
        trialRows={trialRows}
        onViewUser={handleViewUser}
        page={page}
        limit={limit}
        totalCount={totalCount}
        onPageChange={(newPage) => setPage(newPage)}
        onLimitChange={(newLimit) => {
          setLimit(newLimit);
          setPage(0);
        }}
      />
    </Box>
  );
}
